import {Client} from '@stomp/stompjs'

let l = window.location;

let baseUrl = (l.protocol === 'https:' ? 'wss' : 'ws') + '://' + l.host + l.pathname
let brokerUrl = baseUrl.charAt(baseUrl.length - 1) === '/' ? baseUrl + 'socket': baseUrl + '/socket'
const client = new Client()
client.brokerURL = brokerUrl

const wrapper = {
    rawClient: client,
    pendingSubscriber: [],
    activate(){this.rawClient.activate()},
    deactivate(){this.rawClient.deactivate()},
    isStarted(){return this.rawClient.connected},
    subscribe(destination, callback){
        if(this.rawClient.connected){
            return this.rawClient.subscribe(destination, callback)
        } else {
            let subscriber = {
                destination,
                callback,
                subscription: null,
                send(url, object, body){
                    if(this.subscription){
                        this.subscription.send(url, object, body);
                    }
                },
                unsubscribe(){
                    if(this.subscription){
                        this.subscription.unsubscribe()
                    }
                }
            }
            this.pendingSubscriber.push(subscriber)
            return subscriber
        }

    },
}

client.configure({
    onConnect(){
        wrapper.pendingSubscriber.forEach(s => {
            s.subscription = client.subscribe(s.destination, s.callback, {})
        })
        wrapper.pendingSubscriber = []
    }
})


const SocketService =  {
    install(Vue, options){
        Vue.prototype.$socket = wrapper
    }
}
export default SocketService